import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable, catchError} from 'rxjs';
import {DataService} from '../data.service';
import {RatesFrtAccessorialsProcure} from 'src/app/shared/common-components/common-structure';

@Injectable({
  providedIn: 'root'
})
export class FrtAccessorialsMasterService extends DataService {


  private baseURI = this.apiUri + '/frtaccessorialsmaster/';

  constructor(http: HttpClient) {
    super(http);
  }

  getAll(): Observable<any> {
    this.setUri(this.baseURI);
    return this.get();
  }

  getUniqueAccessorials(): Observable<any> {
    const URI = this.apiUri + `/frtaccessorialsmaster/master/`;
    this.setUri(URI);
    return this.get();
  }

  getUnits(unitsId): Observable<any> {
    this.setUri(this.baseURI + 'units/');
    let params = new HttpParams();
    params = params.set('unitsId', unitsId);
    return this.get({params});
  }

  getFrtAcessorialsMasterByCarrierIdAndSroMasterId(sroMasterId: number): Observable<RatesFrtAccessorialsProcure[]> {
    // this.setUri(this.baseURI + 'accessorialsBySroMasterId/' + sroMasterId + '/sroMasterId/' + carrierId + '/carrierId');
    this.setUri(this.baseURI + 'accessorialsBySroMasterId/' + 918 + '/sroMasterId/');
    return this.get().pipe(catchError(this.handleError));
  }

  /**
   * @description gets the list of accessorial codes based on carrierId and sro masterId for FRT business type.
   */
  getFrtAcessorialsMasterByCarrierId(carrierId: number, sroMasterId: number): Observable<any> {

    return this.http.get(this.apiUri + '/ratesfrtaccessorials/accessorialsForFrtRateEdit/' + sroMasterId + '/sroMasterId/' + carrierId + '/carrierId');
  }

  updateFrtRatesAccProcure(frtAccProcList: RatesFrtAccessorialsProcure[]): Observable<any> {
    this.setUri(this.apiUri + '/ratesfrtaccessorials/updateFrtAccessorials');
    return this.update(frtAccProcList);
  }
  deleteFrtRatesAccProcure(procureIdArray: number[]): Observable<any> {
    this.setUri(this.apiUri + '/ratesfrtaccessorials/deleteFrtAccessorials');
    return this.update(procureIdArray);
  }

  /**
   * @description return API to save FRT global update
   */
  saveFrtGlobalUpdate(payload) {
    return this.http.put(this.apiUri + '/ratesfrt/updateFrtGlobalRates', payload);
  }

  getAllMasterToValidate(): Observable<any> {
    return this.http.get(this.apiUri + '/frtaccessorailmaster/');
  }

  getAllAccMasterToValidate(): Observable<any> {
    return this.http.get(this.apiUri + '/frtaccessorialsmaster/');
  }

  /**
   * @description gets the user description based on units id
   */
  getUnitsDescriptionById(unitsId) {
    return this.http.get(this.apiUri + '/frtaccessorialsmaster/units/' + unitsId + '/unitsId');
  }

  /**
   * @description saves and fetches the results.
   */
  getSaveFrtQueryResults(payload) {
    return this.http.post(this.apiUri + '/frtshoprates', payload);
  }

  getFrtServiceOfferings() {
    return this.http.get(this.apiUri + '/frtTspOfferings');
  }
}

